import { Row, Spin } from 'antd'
import React, { Suspense } from 'react'

function withSuspense(Component: React.ComponentType, fullPage: boolean = false) {
  return (props: any) => {
    return (
      // TODO: Add error boundary
      <Suspense
        fallback={
          <Row style={{ width: '100%', height: '100vh' }} align={'middle'} justify={'center'}>
            <Spin size="large" />
          </Row>
        }>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <Component {...props} />
      </Suspense>
    )
  }
}

export default withSuspense
